import ProgressLoader from "@Components/ProgressLoader/ProgressLoader";
import { PlaneProgressIcon } from "src/assets/Icons";
import { FC, useEffect, useRef, useState } from "react";

const FakeLoader: FC<{ isOn: boolean, restart:any }> = ({ isOn, restart }) => {
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(false);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  //should use the spinTheWheel hook for a smoother transition and cool speeds.. todo
  useEffect(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    if (isOn) {
      setProgress(0);
      setVisible(true);
      intervalRef.current = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 96) return prev;
          const increment = 0.01 * (95 - prev);
          return Math.min(prev + increment, 95);
        });
      }, 200);
    } else {
      setProgress(100);
    }
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [isOn, restart]);

  if (!visible) return null;

  return (
    <ProgressLoader
      head={<PlaneProgressIcon className="text-icon-active" mirrorInRtl />}
      progress={progress}
    />
  );
};

export default FakeLoader;
